import { Reducer } from 'redux';

import { Action, createAction } from '../../../store/actionUtils';

export interface LiveNotification {
    isReplay?: boolean;
    title?: string;
    videoID?: string;
}

export interface HeroState {
    liveNotification: LiveNotification;
    stream: string;
    url: string;
}

export enum HeroActionTypes {
    RECEIVE_HERO_URL = 'ShowsIndex/hero/RECEIVE_HERO_URL',
    RECEIVE_HERO_STREAM = 'ShowsIndex/hero/RECEIVE_STREAM',
    RECEIVE_LIVE_NOTIFICATION = 'ShowsIndex/hero/RECEIVE_LIVE_NOTIFICATION',
}

export type ReceiveHeroURLAction = Action<HeroActionTypes.RECEIVE_HERO_URL, string>;
export type ReceiveHeroStreamAction = Action<HeroActionTypes.RECEIVE_HERO_STREAM, string>;
export type ReceiveLiveNotificationAction = Action<HeroActionTypes.RECEIVE_LIVE_NOTIFICATION, LiveNotification>;
export type HeroAction = ReceiveHeroURLAction | ReceiveHeroStreamAction | ReceiveLiveNotificationAction;

const initialState: HeroState = {
    liveNotification: {},
    stream: '',
    url: '',
};

const heroReducer: Reducer<HeroState, HeroAction> = (state = initialState, action) => {
    switch (action.type) {
        case HeroActionTypes.RECEIVE_HERO_STREAM:
            return {
                ...state,
                stream: action.payload,
            };
        case HeroActionTypes.RECEIVE_HERO_URL:
            return {
                ...state,
                url: action.payload,
            };
        case HeroActionTypes.RECEIVE_LIVE_NOTIFICATION:
            const { isReplay, title, videoID } = action.payload;
            return {
                ...state,
                liveNotification: {
                    isReplay,
                    title,
                    videoID,
                },
            };
        default:
            return state;
    }
};

// Action creators
export const receiveHeroURL = createAction<ReceiveHeroURLAction>(HeroActionTypes.RECEIVE_HERO_URL);
export const receiveHeroStream = createAction<ReceiveHeroStreamAction>(HeroActionTypes.RECEIVE_HERO_STREAM);
export const receiveLiveNotification = createAction<ReceiveLiveNotificationAction>(HeroActionTypes.RECEIVE_LIVE_NOTIFICATION);

export default heroReducer;
